import { fileToString } from '@shared/lib/utils/file-to-string/file-to-string';
import { IFileData } from '@vtbhome/juicyfront/types';

export const createFileData = async (files: FileList | File[] | null) => {
    const result = [] as IFileData[];
    const arrayFiles = Array.from(files || []);
    for (const file of arrayFiles) {
        const base64 = await fileToString(file);
        result.push({
            file,
            base64,
        });
    }
    return result;
};
